import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var TableExhibitsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M12 4.688a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        }),
                        _jsx("path", {
                            d: "M15 6.488a1 1 0 00-1-1h-4a1 1 0 00-1 1v3a1 1 0 001 1h4a1 1 0 001-1v-3zm-1.333 1v1h-3.334v-1h3.334zM7 5.488a1 1 0 011 1v3a1 1 0 01-1 1H3a1 1 0 01-1-1v-3a1 1 0 011-1h4zm-.333 3v-1H3.333v1h3.334z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M20.1 3.588a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0z"
                        }),
                        _jsx("path", {
                            d: "M21 5.488a1 1 0 011 1v3a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3a1 1 0 011-1h4zm-.333 3v-1h-3.334v1h3.334z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M6.1 3.588a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM6.1 20.388a1.1 1.1 0 10-2.2 0 1.1 1.1 0 002.2 0z"
                        }),
                        _jsx("path", {
                            d: "M7 18.488a1 1 0 001-1v-3a1 1 0 00-1-1H3a1 1 0 00-1 1v3a1 1 0 001 1h4zm-.333-3v1H3.333v-1h3.334z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M12 19.288a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2z"
                        }),
                        _jsx("path", {
                            d: "M15 17.488a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3a1 1 0 011-1h4a1 1 0 011 1v3zm-1.333-1v-1h-3.334v1h3.334z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M20.1 20.388a1.1 1.1 0 10-2.2 0 1.1 1.1 0 002.2 0z"
                        }),
                        _jsx("path", {
                            d: "M21 18.488a1 1 0 001-1v-3a1 1 0 00-1-1h-4a1 1 0 00-1 1v3a1 1 0 001 1h4zm-.333-3v1h-3.334v-1h3.334z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        })
                    ]
                })
            })
        ]
    });
};
TableExhibitsIcon.isCarinaIcon = true;
export default TableExhibitsIcon;
